<script>
import partner3 from '@/assets/img/partners/mutiny_logo.png';
import Typography from '@/components/v3/base/Typography';
import Logo1 from '@/assets/img/partners/ssr_logo.png';
import Logo2 from '@/assets/img/partners/partner3.png';
import Logo4 from '@/assets/img/partners/partner2.svg';
import ArrowLeft from '@/assets/icons/left-arrow-primary.svg';

export default {
  components: {
    Typography,
  },

  data() {
    return {
      ArrowLeft,
      testimonials: [
        {
          logo: partner3,
          logoH: 'tw-h-13',
          url: '',
          avatar: 'https://i.ibb.co/hKRYfRr/1608691255914.jpg',
          name: 'Soinneah Monks',
          title: 'Head of Talent, Mutiny',
          text: "Hirefly was able to deliver top quality candidates and help us fill high priority roles quickly while providing incredible client management. I've never worked with an AI based sourcing platform before, and while I was skeptical initially, Hirefly is paving the path for sourcing in the future.",
        },
        {
          logo: Logo1,
          logoH: 'tw-h-10',
          url: 'https://selectsoftwarereviews.com/',
          avatar: 'https://i.ibb.co/qyKfTjd/phil-strazzula-pic.jpg',
          name: 'Phil Strazzula',
          title: 'Founder, Select Software Reviews',
          text: 'Hirefly represents what talent acquisition teams have been searching for when it comes to AI recruiting platforms - the ability to get high-quality candidates on your calendar quickly with little effort.',
        },
        {
          logo: Logo2,
          logoH: 'tw-h-6',
          url: '',
          avatar: 'https://i.ibb.co/FVwngdT/rachel-prof-pic.jpg',
          name: 'Rachel Sanders',
          title: 'Co-Founder and CEO, Rootine',
          text: `We hired our Head of Engineering in under 6 weeks. Hirefly provided great candidates excited to interview with me. I didn't need to do any sourcing myself. We saved 90% on our hiring costs and look forward to partnering on future roles.`,
        },
        {
          logo: Logo4,
          logoH: 'tw-h-12',
          url: '',
          avatar: 'https://i.ibb.co/VNr89Tc/serena-prof-pic.jpg',
          name: 'Serena Taylor',
          title: 'Director of Operations, Knox Financials',
          text: `We hire across a lot of sectors. It's so helpful to have sophisticated curation of potential talent in a user-friendly tool. We’ve made two really successful hires using Hirefly in just the past 3 months of use!`,
        },
      ],

      containerWidth: 0,
      activeIdx: 0,
      containerHeight: 'auto',
    };
  },

  computed: {
    testimonialsDisplay() {
      const arr = [];
      this.testimonials.forEach((item) => {
        const arr1 = [];
        arr1.push(item);
        arr.push({
          items: [...arr1],
        });
      });
      return arr;
    },
  },

  mounted() {
    window.addEventListener('resize', this.onResize, true);
    this.onResize();
  },

  unmounted() {
    window.removeEventListener('resize', this.onResize, true);
  },

  methods: {
    onResize() {
      this.containerWidth = window.innerWidth;
      this.setContainerHeight();
    },

    onNext() {
      this.activeIdx += 1;
      if (this.activeIdx === this.testimonialsDisplay.length) {
        this.activeIdx = 0;
      }
    },

    onPrev() {
      this.activeIdx -= 1;
      if (this.activeIdx < 0) {
        this.activeIdx = this.testimonialsDisplay.length - 1;
      }
    },

    setContainerHeight() {
      const items = this.$refs.testimonialRef;
      let max = 0;
      items.forEach((el) => {
        const h = el.offsetHeight;
        if (h > max) max = h;
      });
      this.containerHeight = max;
    },
  },
};
</script>
<!-- eslint-disable vue/no-undef-components -->
<template>
  <div class="tw-w-full tw-bg-white tw-rounded-2xl tw-py-4 tw-relative">
    <div
      class="tw-absolute tw-right-14 tw-top-6 tw-z-10 tw-cursor-pointer tw-mr-6 tw-w-10"
      @click="onPrev"
    >
      <img :src="ArrowLeft" alt="" />
    </div>
    <div
      class="tw-absolute tw-right-6 tw-top-6 tw-z-10 tw-cursor-pointer tw-ml-4 tw-w-10"
      @click="onNext"
    >
      <img :src="ArrowLeft" alt="" class="tw-rotate-180" />
    </div>
    <div
      class="tw-h-[280px] tw-overflow-hidden tw-relative"
      :style="{ height: containerHeight + 'px' }"
    >
      <div
        v-for="(testimonial, i) in testimonialsDisplay"
        ref="testimonialRef"
        :key="'testimonial' + i"
        class="tw-flex tw-items-center tw-py-4 tw-min-h-full tw-absolute tw-top-0 tw-left-0 tw-w-full tw-transition-all tw-ease-in-out tw-duration-300"
        :class="{
          '!tw-translate-x-0': activeIdx === i,
          'tw-translate-x-full': activeIdx > i,
          '-tw-translate-x-full': activeIdx < i,
        }"
      >
        <div
          v-for="(element, j) in testimonial.items"
          :key="'child' + j"
          class="tw-flex tw-w-full tw-px-3 tw-border-0 tw-border-l tw-border-solid tw-border-gray-200 tw-min-h-full"
        >
          <div class="tw-px-4 tw-pb-2 tw-flex tw-flex-col tw-h-full">
            <div>
              <div class="tw-w-full tw-h-10 tw-items-center tw-flex">
                <component
                  :is="element.url ? 'a' : 'div'"
                  :href="element.url"
                  class="tw-inline-block"
                  :class="{ '-tw-ml-10': i === 3 }"
                >
                  <img :src="element.logo" :class="element.logoH" alt="" />
                </component>
              </div>
              <Typography variant="headline-6" class="tw-pt-6">
                "{{ element.text }}"
              </Typography>
            </div>
            <div class="tw-mt-6 tw-flex tw-gap-3 tw-items-center">
              <div>
                <div class="tw-w-12 tw-h-12 tw-rounded-full tw-overflow-hidden">
                  <img
                    :src="element.avatar"
                    :alt="element.name"
                    class="tw-max-w-full tw-max-h-full"
                  />
                </div>
              </div>
              <div class="tw-text-left">
                <Typography variant="subtitle-2">
                  {{ element.name }}
                </Typography>
                <Typography variant="body-2">{{ element.title }}</Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
